import { useEffect } from 'react'
import { useFiatCurrencyStore } from './FiatCurrencyStore'
import { useTRPCClient } from '@/api/trpc/context'

export const FiatCurrencyProvider: React.FC = () => {
  const loadRates = useFiatCurrencyStore((s) => s.loadRates)

  const trpc = useTRPCClient()

  useEffect(() => {
    trpc.public.fiatRates.getRates
      .query()
      .then((data) => {
        //  loadRates({ rates: data.rates, symbols: data.symbols, names: data.names })
      })
      .catch(() => {
        // fallback: USD only, already set as default
      })
  }, [])

  return null
}
